import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "../components/layout_components/sidenav";
import { Mainlaystyle } from "../styles/layout";
import { useTheme } from "@mui/material/styles";
// import Header from "../components/layout_components/header";

const MainLayout = () => {
    const theme = useTheme();
    const classes = Mainlaystyle(theme);
    return (
        <Box sx={classes.rootBox}>
            <Sidebar />
            <Box sx={classes.componentDiv}>
                {/* <Box sx={classes.HeaderDiv}>
                    <Header />
                </Box> */}

                <Box sx={classes.outletDiv}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}

export default MainLayout